import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/Hero";
import AboutSection from "../components/AboutSection";
import RestaurantsPreview from "../components/RestaurantsPreview";
import AnalyticsSection from "../components/AnalyticsSection";
import ContactSection from "../components/ContactSection";

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [location]);

  return (
    <main data-testid="home-page">
      <Hero />
      <AboutSection />
      <RestaurantsPreview />
      <AnalyticsSection />
      <ContactSection />
    </main>
  );
}
